export default "__VITE_ASSET__BqnTwkI2__"